<template>
  <div id="content-container">
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="visible = true"
        v-permission="Auth.roleNew"
        >新增角色</el-button
      >
      <el-table :data="roles" size="small" class="mt-10">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="角色名"
          width="120"
        ></el-table-column>
        <el-table-column align="center" label="状态" width="200">
          <template slot-scope="scope">
            <span
              :class="scope.row.status == 1 ? 'text-success' : 'text-danger'"
            >
              {{ scope.row.status == 1 ? '已启用' : '已禁用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="desc"
          label="描述"
        ></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <template v-if="scope.row.name != '超级管理员'">
              <el-popconfirm
                v-permission="Auth.roleStatus"
                :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}吗？`"
                @confirm="handleSwitchStatus(scope.$index, scope.row.id)"
              >
                <el-button slot="reference" type="danger" plain size="mini">{{
                  scope.row.status == 1 ? '禁用' : '启用'
                }}</el-button>
              </el-popconfirm>
              <el-button
                class="ml-10"
                type="primary"
                plain
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                v-permission="Auth.roleEdit"
                >编辑</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="roleForm.id ? '编辑角色' : '新增角色'"
        :visible.sync="visible"
        :close-on-click-modal="false"
        @closed="resetForm('roleForm')"
      >
        <el-form
          :model="roleForm"
          :rules="rules"
          ref="roleForm"
          label-width="90px"
          size="small"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="roleForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input
              type="textarea"
              v-model="roleForm.desc"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="权限设置">
            <el-tree
              ref="tree"
              :data="routesData"
              :props="defaultProps"
              show-checkbox
              node-key="code"
              class="permission-tree"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitForm('roleForm')" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  roleList,
  createOrUpdateRole,
  swtichRoleStatus,
  deleteRole,
  authList,
} from '@/service/getData'

export default {
  data() {
    return {
      checkStrictly: false,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      roleForm: {
        id: 0,
        name: '',
        desc: '',
      },
      editIndex: 0,
      rules: {
        name: [
          { required: true, message: '请填写角色名', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
      },
      roles: [],
      visible: false,
      auths: [],
    }
  },
  created() {
    this.getRoles()
    this.getAuths()
  },
  computed: {
    routesData() {
      return this.auths
    },
  },
  methods: {
    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.sort(function (a, b) {
          return a.status - b.status
        })
      }
    },

    filterTree(tree = [], filterPlatform = 0, arr1 = [], arr2 = []) {
      if (!tree.length) return []
      for (let item of tree) {
        if (
          item.platform == filterPlatform ||
          item.platform == 3 ||
          item.platform == -1
        )
          continue
        let node = { ...item, children: [] }
        if (item.codes[0]) {
          node.code = item.codes[0]
          arr1.push(node)
        }

        let node1 = { ...item, children: [] }
        if (item.codes[1]) {
          node1.code = item.codes[1]
          arr2.push(node1)
        }

        if (item.children && item.children.length)
          this.filterTree(
            item.children,
            filterPlatform,
            node.children,
            node1.children
          )
      }
      return [arr1, arr2]
    },

    async getAuths() {
      let res = await authList()
      if (res.code == 0) {
        let auths = this.filterTree(res.data.list, 2)

        this.auths = auths[0]
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const checkedKeys = this.$refs.tree.getCheckedKeys()

          let data = this.roleForm
          data.codes = checkedKeys.filter(
            (item) => item != undefined && item != ''
          )

          if (this.roleForm.id) {
            let res = await createOrUpdateRole(data)
            if (res.code == 0) {
              this.$set(this.roles, this.editIndex, res.data)
              this.visible = false
            }
          } else {
            let res = await createOrUpdateRole(data)
            if (res.code == 0) {
              this.roles.unshift(res.data)
              this.visible = false
            }
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.roleForm.id = 0
      this.$refs.tree.setCheckedKeys([])
    },
    handleEdit(index, item) {
      this.editIndex = index
      let codes = []
      if (item.auths) {
        item.auths.map((item) => {
          codes = codes.concat(eval(item.chosed_codes))
        })
      }

      this.visible = true
      this.$nextTick(() => {
        this.roleForm = {
          id: item.id,
          name: item.name,
          desc: item.desc,
        }

        this.$refs.tree.setCheckedKeys(codes)
      })
    },
    async handleSwitchStatus(index, id) {
      let res = await swtichRoleStatus(id)
      if (res.code == 0) {
        this.roles[index].status = this.roles[index].status == 1 ? 2 : 1
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
    async handleDelete(index, id) {
      let res = await deleteRole(id)
      if (res.code == 0) {
        this.roles.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.permission-tree {
  background: none;
  margin-top: 5px;
}
</style>